import React from "react";
import IWidgetProps from "../../../../../model/interface/widget/IWidgetProps";
import IFormElementFunctions from "../../../../../model/interface/form/IFormElementFunctions";
import {Col, Row} from "antd";
import IframeWidget from "../../widget/IframeWidget";
import IFormIframeOptions from "../../../../../model/interface/form/elementOptions/IFormIframeOptions";

interface IProps extends IWidgetProps<IFormElementFunctions, IFormIframeOptions> {
}

interface IState {
    conditionMet?: boolean
    remoteConditionMet?: boolean
}

class FormElementIframe extends React.Component<IProps, IState> {
    render() {
        const {functions, options} = this.props
        const url = options.field ? functions.getResourceValue(options.field) : options.url
        if (Array.isArray(url)){
            return <Row gutter={[12, 12]}>
                { url.map(item => (
                    <Col span={24} key={item}>
                        <IframeWidget {...this.props} options={{...options, url: item}}/>
                    </Col>
                ))}
            </Row>
        }

        return (
            <IframeWidget {...this.props} options={{...options, url}}/>
        );
    }
}
export default FormElementIframe